<template>
  <view-linkable :content-element="contentElement" :entry="entry">
    <img v-bind:height="imgHeight" :src="imgSrc" :alt="imgAlt" :class="classes">
  </view-linkable>
</template>

<script lang="ts">
  import Vue from "vue";
  import listViewTableMixin from "../mixins/listViewTableMixin";
  import {Hash} from "../../../common/interfaces/hashInterfaces"
  import {ListViewIconSize} from "../../../common/models/listViews/listViewIconSize"

  export default Vue.extend({
    mixins: [
      listViewTableMixin,
    ],
    data: function () {
      return {};
    },
    computed: {
      contentElementData() {
        return this.entry.view_data?.content_element_data?.[this.contentElement.client_id];
      },
      imgSrc() {
        return this.contentElementData?.url;
      },
      imgAlt() {
        return this.contentElementData?.name;
      },
      classes(): Hash<boolean> {
        const classes: Hash<boolean> = {};
        switch (this.contentElement.icon_size) {
          case ListViewIconSize.small:
            classes.small = true;
            break;
          case ListViewIconSize.large:
            classes.large = true;
            break;
          default:// ListViewIconSize.medium
            classes.medium = true;
            break;
        }
        return classes
      },
      imgHeight(): number {
        switch (this.contentElement.icon_size) {
          case ListViewIconSize.small:
              return 30;
          case ListViewIconSize.large:
              return 80;
          default:
              return 50;
        }
      }
    },
  });
</script>